import React, { useState, useEffect } from 'react';
import { api } from '../api';
import { categoryEmoji } from '../categoryEmoji';
import { getCachedData } from '../store';
import { todayISO, formatDate } from '../dateUtils';

export default function Statistics() {
  const [periods, setPeriods] = useState([]);
  const [selectedPeriodId, setSelectedPeriodId] = useState('');
  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [type, setType] = useState('all');
  const [stats, setStats] = useState([]);

  // Текущий (актуальный) период: сегодня в диапазоне, иначе первый
  const pickCurrentPeriod = (list) => {
    if (!list || list.length === 0) return null;
    const today = todayISO();
    return list.find(p => today >= p.startDate && today <= p.endDate) || list[0];
  };

  useEffect(() => {
    const cached = getCachedData();
    if (cached) {
      if (Array.isArray(cached.periods)) setPeriods(cached.periods);
      if (Array.isArray(cached.categories)) setCategories(cached.categories);
      const period = pickCurrentPeriod(cached.periods);
      if (period) setSelectedPeriodId(period.id);
    }
    const load = async () => {
      const periodsData = await api.getPeriods();
      const cats = await api.getCategories();
      setPeriods(periodsData);
      setCategories(cats);
      const period = pickCurrentPeriod(periodsData);
      if (period) setSelectedPeriodId(period.id);
    };
    load();
  }, []);

  useEffect(() => {
    if (selectedPeriodId) {
      const params = { periodId: selectedPeriodId };
      if (selectedCategoryId) params.categoryId = selectedCategoryId;
      if (type !== 'all') params.type = type;
      api.getStatistics(params).then(setStats);
    }
  }, [selectedPeriodId, selectedCategoryId, type]);

  return (
    <div className="content">
      <h1>Статистика</h1>
      <div className="form-group">
        <label>Период</label>
        <select value={selectedPeriodId} onChange={(e) => setSelectedPeriodId(e.target.value)}>
          {periods.map(p => (
            <option key={p.id} value={p.id}>{formatDate(p.startDate)} — {formatDate(p.endDate)}</option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label>Категория</label>
        <select value={selectedCategoryId} onChange={(e) => setSelectedCategoryId(e.target.value)}>
          <option value="">Все категории</option>
          {categories.map(c => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label>Тип</label>
        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="all">Все</option>
          <option value="expense">Расходы</option>
          <option value="income">Доходы</option>
        </select>
      </div>

      <div className="card">
        <div className="card-title">Сводка</div>
        {stats.length === 0 && <div style={{ color: 'var(--text-dim)', textAlign: 'center', padding: '10px 0' }}>Нет данных за выбранный период</div>}
        {stats.map((s, index) => (
          <div key={index} className="stats-row">
            <span className="stats-name">
              <span className="cat-icon">{categoryEmoji(s.categoryName)}</span>
              {s.categoryName}
            </span>
            <span className={`amount ${s.type === 'expense' ? 'amount-expense' : 'amount-income'}`}>{s.total} ₽</span>
          </div>
        ))}
      </div>
    </div>
  );
}
